import styled from 'styled-components';

export const Content = styled.section`
  background: white;
`